import React, { useState, useEffect, useRef } from 'react';

const testimonials = [
    {
        initials: 'IV',
        name: 'Ivana & Matej',
        color: '#fce7f3',
        textColor: '#be185d',
        stars: 5,
        quote: 'Gosti su oduševljeni što sami biraju gdje i s kim sjede. Nismo očekivali da će to biti tako jednostavno.',
    },
    {
        initials: 'PL',
        name: 'Petra & Luka',
        color: '#d1fae5',
        textColor: '#047857',
        stars: 5,
        quote: 'Konacni popis gostiju bio je puno tocniji nego inace. Ustedili smo nekoliko stolica koje bi ionako ostale prazne i to nije zanemariv trosak.',
    },
    {
        initials: 'AN',
        name: 'Ana & Nikola',
        color: '#dbeafe',
        textColor: '#1d4ed8',
        stars: 5,
        quote: 'Mislila sam da će raspored sjedenja biti najstresniji dio planiranja. Dodam goste, pošaljem link i gotovo.',
    },
    {
        initials: 'KL',
        name: 'Katarina & Luka',
        color: '#e0f2fe',
        textColor: '#0369a1',
        stars: 4,
        quote: 'Treba malo vremena da se pohvataju sve opcije na početku, ali kad smo skužili kako radi, stvarno nam je olakšalo organizaciju, pogotovo oko potvrda dolaska.',
    },
    {
        initials: 'MT',
        name: 'Maja & Tomislav',
        color: '#fef3c7',
        textColor: '#b45309',
        stars: 5,
        quote: 'Tetki sam poslala link, ona je potvrdila za cijelu obitelj i odabrala stol. Obiteljska pozivnica je super stvar.',
    },
    {
        initials: 'MB',
        name: 'Marko & Barbara',
        color: '#ede9fe',
        textColor: '#6d28d9',
        stars: 5,
        quote: 'Rucno pisanje, Excel tablice, grupni WhatsApp... Probali smo sve. Ovo je jedino sto zapravo ima smisla.',
    },
    {
        initials: 'NA',
        name: 'Nina & Ante',
        color: '#fce7f3',
        textColor: '#be185d',
        stars: 5,
        quote: 'Uštedjeli smo hrpu stresa, a raspored je bio gotov tjedan prije svadbe.',
    },
];

const Avatar = ({ initials, color, textColor }) => (
    <div
        className="w-11 h-11 rounded-2xl flex items-center justify-center text-sm font-bold shrink-0"
        style={{ background: color, color: textColor }}
    >
        {initials}
    </div>
);

const Stars = ({ count }) => (
    <div className="flex gap-0.5 mb-3">
        {[...Array(5)].map((_, i) => (
            <svg key={i} width="14" height="14" viewBox="0 0 24 24" fill={i < count ? '#f59e0b' : '#e7e5e4'}>
                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
            </svg>
        ))}
    </div>
);

const Card = ({ t }) => (
    <div className="bg-white border-[1.5px] border-stone-100 rounded-3xl p-6 flex flex-col gap-3 hover:border-rose-200 hover:shadow-lg transition-all duration-300">
        <Stars count={t.stars} />
        <p className="text-[14px] text-stone-600 leading-relaxed flex-1">
            "{t.quote}"
        </p>
        <div className="pt-3 border-t border-stone-100 flex items-center gap-2.5">
            <Avatar initials={t.initials} color={t.color} textColor={t.textColor} />
            <span className="text-[13px] font-semibold text-stone-900">{t.name}</span>
        </div>
    </div>
);

const TestimonialsSection = () => {
    const [active, setActive] = useState(0);
    const timerRef = useRef(null);

    const startTimer = () => {
        clearInterval(timerRef.current);
        timerRef.current = setInterval(() => {
            setActive(s => (s + 1) % testimonials.length);
        }, 4500);
    };

    const handleDot = (index) => {
        setActive(index);
        startTimer();
    };

    useEffect(() => {
        startTimer();
        return () => clearInterval(timerRef.current);
    }, []);

    return (
        <section id="recenzije" className="py-24 px-6 bg-white">
            <div className="max-w-[1100px] mx-auto">

                {/* Header */}
                <div className="text-center mb-14">
                    <div
                        className="inline-flex items-center gap-2.5 border-[1.5px] border-rose-200 rounded-full py-2 px-5 mb-5"
                        style={{ background: 'linear-gradient(135deg, #fce7f3, #fff7ed)' }}
                    >
                        <span className="text-xl">💬</span>
                        <span className="text-[13px] font-bold text-rose-700 tracking-wide uppercase">Iskustva mladenaca</span>
                    </div>
                    <h2
                        className="font-display font-bold text-stone-900 tracking-tight mb-4"
                        style={{ fontSize: 'clamp(30px, 3.5vw, 46px)' }}
                    >
                        Što kažu oni koji su već{' '}
                        <span className="text-rose-600 italic">koristili Weddinfy</span>
                    </h2>
                </div>

                {/* Desktop grid */}
                <div className="hidden md:grid grid-cols-3 gap-4">
                    {testimonials.map((t, i) => (
                        <Card key={i} t={t} />
                    ))}
                </div>

                {/* Mobile carousel */}
                <div className="md:hidden">
                    <div
                        className="relative overflow-hidden rounded-3xl border-[1.5px] border-stone-100"
                        style={{ minHeight: 270 }}
                    >
                        {testimonials.map((t, i) => (
                            <div
                                key={i}
                                className="absolute inset-0 p-6 flex flex-col gap-3 bg-white transition-all duration-500 ease-out"
                                style={{
                                    opacity: i === active ? 1 : 0,
                                    transform: i === active
                                        ? 'translateX(0)'
                                        : i < active
                                            ? 'translateX(-40px)'
                                            : 'translateX(40px)',
                                    pointerEvents: i === active ? 'auto' : 'none',
                                }}
                            >
                                <Stars count={t.stars} />
                                <p className="text-[14px] text-stone-600 leading-relaxed flex-1">
                                    "{t.quote}"
                                </p>
                                <div className="pt-3 border-t border-stone-100 flex items-center gap-2.5">
                                    <Avatar initials={t.initials} color={t.color} textColor={t.textColor} />
                                    <span className="text-[13px] font-semibold text-stone-900">{t.name}</span>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Dots */}
                    <div className="flex justify-center gap-2 mt-4">
                        {testimonials.map((_, i) => (
                            <button
                                key={i}
                                onClick={() => handleDot(i)}
                                className={`rounded-full transition-all duration-300 ${i === active ? 'w-6 h-2 bg-rose-500' : 'w-2 h-2 bg-stone-300 hover:bg-stone-400'}`}
                                aria-label={`Recenzija ${i + 1}`}
                            />
                        ))}
                    </div>
                </div>

                {/* Bottom trust strip */}
                <div className="mt-12 flex justify-center">
                    <div className="inline-flex items-center gap-3 bg-stone-50 border border-stone-200 rounded-2xl px-6 py-3">
                        <div className="flex gap-0.5">
                            {[...Array(5)].map((_, i) => (
                                <svg key={i} width="15" height="15" viewBox="0 0 24 24" fill="#f59e0b">
                                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                                </svg>
                            ))}
                        </div>
                        <span className="text-[13px] text-stone-500">
                            Većina parova smatra organizaciju{' '}
                            <span className="font-semibold text-stone-900">jednostavnijom nego što su očekivali</span>
                        </span>
                    </div>
                </div>

            </div>
        </section>
    );
};

export default TestimonialsSection;
